module.exports = __webpack_public_path__ + "static/media/annoation-hand.d17995db.gif";